import { render, staticRenderFns } from "./Bedankt.vue?vue&type=template&id=165580b6&"
import script from "./Bedankt.vue?vue&type=script&lang=js&"
export * from "./Bedankt.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports